module.exports = __webpack_public_path__ + "static/media/chevron-blue-right.c8f09f5d.svg";